<template>
  <div class="card modal-card min-width-1250px">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <qd-steps
          v-model="activeStep"
          :has-navigation="false"
          :animated="true" :rounded="true"
          class="stepfullWidth"
          mobile-mode="compact"
          label-position="bottom"
          :stepsItems="stepsItems">
          <template #encart>
            <h1 class="title has-text-centered">
              {{ $t('ajoutPresseDcf.popupSelection.selectionEncart') }}
            </h1>
            <liaisons-tarif
              :produit="produit"
              :liaisons-tarif="encarts"
              :isEncart="true"
              class="mgt-20px">
            </liaisons-tarif>
          </template>

          <template #produit>
            <h1 class="title has-text-centered" >
              {{ $t('ajoutPresseDcf.popupSelection.selectionProduitAssocie') }}
            </h1>
            <liaisons-tarif
              :produit="produit"
              :liaisons-tarif="liaisonsTarif"
              class="mgt-20px">
            </liaisons-tarif>
          </template>

          <template #parutions>
            <h1 class="title has-text-centered mgb-20px">
              {{ $t('ajoutPresseDcf.popupSelection.selectionParution') }}
            </h1>
            <selection-parution
              v-if="showSelectionParution"
              :produit="produit"
              :liaisons-tarif="liaisonsTarif"
              :emplacementId="getEmplacementOfEncartSelected"
              :surfaceId="getSurfaceOfEncartSelected"
              :onlyOneSelect="false">
            </selection-parution>
          </template>
        </qd-steps>
        <div class="columns is-justify-content-space-between">
          <b-field class="column is-narrow is-paddingless mgl-20px">
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
          </b-field>
          <b-field class="column is-narrow is-paddingless">
            <div class="is-pulled-left boutonAction" v-if="activeStep !== 0">
              <a class="button" @click="manageActiveStep(-1)">
                {{ $t('general.button.precedent')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction mgr-20px" v-if="!showSelectionParution">
              <a class="button is-addOrEdit" @click="manageActiveStep(1)"
                 :class="encartSelected === true ? '' : 'disabled'">
                {{ $t('general.button.suivant') }}
              </a>
            </div>
            <div class="is-pulled-left boutonAction mgr-20px" v-if="showSelectionParution">
              <a class="button is-addOrEdit" @click="addInDcf()">
                {{ $t('ajoutPresseDcf.popupSelection.addInCart') }}
              </a>
            </div>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import liaisonsTarif
  from '@/components/devisCommandes/editionDevisCommande/ajoutLigneViaEcranAjout/liaisonsTarif';
import selectionParution
  from '@/components/devisCommandes/editionDevisCommande/ajoutLigneViaEcranAjout/selectionParution';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import {
  INIT_PARUTION_SELECTED,
} from '@/store/modules/presse/parution-mutation-type';

const Parution = createNamespacedHelpers('parution');

export default {
  name: 'selectionProduitAssocieLiaisonAndParution',
  props: {
    encarts: {
      type: Array,
      required: true,
    },
    liaisonsTarif: {
      type: Array,
      required: true,
    },
    produit: {
      type: Object,
      required: true,
    },
  },
  components: {
    liaisonsTarif,
    selectionParution,
  },
  data() {
    return {
      activeStep: 0,
    };
  },
  methods: {
    ...Parution.mapMutations({
      initParutionSelected: INIT_PARUTION_SELECTED,
    }),
    manageActiveStep(number) {
      this.activeStep += number;
      if (this.activeStep < 0) this.activeStep = 0;
      if (this.activeStep > 2) this.activeStep = 2;
    },
    addInDcf() {
      const prosuitAssocieSelectedId = this.liaisonsTarif
        .filter((el) => el.selected)
        .map((el) => el.id);
      const encartsSelectedId = this.encarts
        .filter((el) => el.selected)
        .map((el) => el.id);
      this.$emit('addInDcf', {
        produitId: this.produit.id,
        liaisonsId: prosuitAssocieSelectedId,
        encartsId: encartsSelectedId,
        parutions: this.parutionsSelected,
      });
    },
  },
  computed: {
    ...Parution.mapGetters({
      parutionsSelected: 'parutionsSelected',
    }),
    getEmplacementOfEncartSelected() {
      const encartFind = this.encarts.find((el) => el.selected);
      if (encartFind) return encartFind.emplacementId;
      return null;
    },
    getSurfaceOfEncartSelected() {
      const encartFind = this.encarts.find((el) => el.selected);
      if (encartFind) return encartFind.surfaceId;
      return null;
    },
    encartSelected() {
      return this.encarts.filter((el) => el.selected).length > 0;
    },
    showStep2() {
      return this.liaisonsTarif.length > 0;
    },
    showSelectionParution() {
      if (this.showStep2) return this.activeStep === 2;
      return this.activeStep === 1;
    },
    stepsItems() {
      const items = [{
        name: 'encart',
        label: this.$t('ajoutPresseDcf.popupSelection.encart'),
        clickable: false,
      }];
      if (this.showStep2) {
        items.push({
          name: 'produit',
          label: this.$t('ajoutPresseDcf.popupSelection.produitAssocie'),
          clickable: false,
        });
      }
      items.push({
        name: 'parutions',
        label: this.$t('ajoutPresseDcf.popupSelection.parutions'),
        clickable: false,
      });
      items.forEach((item, index) => {
        item.step = index + 1;
      });
      return items;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.initParutionSelected([]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
